








































import { Component, Vue, Prop } from "vue-property-decorator";
import SolicitacaoModel from "@/models/Solicitacao";
import moment from "moment";
import VueRouter, { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
// todo mover esses accesso pra outra classe
import firebase from "firebase";
import _debug from "debug";

const debug = _debug("Mediacao:views:SolicitacaoCadastro.vue");

const userModule = getModule(UserModule, store);

Component.registerHooks([
    "beforeRouteEnter",
    // 'beforeRouteLeave',
    // 'beforeRouteUpdate' // for vue-router 2.2+
]);

@Component({
    components: {},
})
export default class SolicitacaoCadastro extends Vue {
    private solicitacao?: SolicitacaoModel;
    private formValid = false;
    private commingFromRoute?: Route;
    private loadingSolicitacao = true;

    private rules: any = {
        titulo: [(v: string) => !!v || "O título é obrigatório!", (v: string) => (v && v.length <= 40) || "O título deve ter no máximo 40 caracteres!"],
        resumo: [(v: string) => !!v || "A descrição é obrigatória!", (v: string) => (v && v.length <= 4000) || "A descrição deve ter no máximo 4000 caracteres!"],
    };

    private get isLoadingSolicitacao() {
        return this.loadingSolicitacao;
    }

    private async created() {
        debug("SolicitacaoCadastro.created: id", this.$route.params.id);
        if (this.$route.params.id === "nova") {
            const userDb = userModule.getUser.userDb;
            if (userDb && userDb.email) {
                this.solicitacao = new SolicitacaoModel(undefined, userDb.email);
                this.loadingSolicitacao = false;
            }
        } else {
            try {
                this.solicitacao = await SolicitacaoModel.fetchById(this.$route.params.id);
                this.loadingSolicitacao = false;
            } catch (error) {
                console.error("Erro buscando solicitação para editar!", error);
            }
        }
    }

    private get dataCriacaoFormatada() {
        if (this.solicitacao) {
            return moment(this.solicitacao.created_at).format("DD/MM/YYYY - HH:mm");
        }
        return "";
    }
    private cancelar() {
        this.$router.go(-1);
    }
    private async salvar() {
        if (this.solicitacao) {
            let solicitacaoSalva = null;
            if (this.solicitacao.id) {
                solicitacaoSalva = await this.solicitacao.save();
            } else {
                solicitacaoSalva = await this.solicitacao.add(undefined, {
                    userParteUm: this.solicitacao.userId,
                });
            }
            debug("Salvou a solicitacao", solicitacaoSalva);
            this.$router.go(-1);
        }
    }
}
